export interface SheetStatistic {
  examineeCount: number;
  schoolCount: number;
  isConfigured: boolean;
}

export interface ExamineeImport {
  examineeCount: number;
  schoolCount: number;
  importId?: string;
  importStatus?: boolean;
}

export enum SystemId {
  Custom,
  Sioepkz,
  Sioeo,
}

export enum ImportExamineeStatus {
  WrongFileExtension,
  EmptyOrWrongFileContent,
  Failed,
  Success,
}
export enum DeleteExamineesOutcome {
  DeletedImmediately = 0,
  ScheduledInBackground = 1,
  NoDataFound = 2,
  AlreadyInProgress = 3,
  Failed = 4
}

export interface DeleteExamineeByFilterResponse{
  outcome: DeleteExamineesOutcome;
  deletedCount: number;
}